import Flickity from 'flickity'
require('flickity-as-nav-for/as-nav-for')

/* eslint-disable no-new */

const loadImageGalleries = () => {
    const imageGalleryLinks = document.querySelectorAll('.room-gallery-link')

    for (let imageGalleryLink of imageGalleryLinks) {
        imageGalleryLink.addEventListener('click', event => {
            event.preventDefault()

            // Find image gallery containers
            const imageGalleryId = imageGalleryLink.getAttribute('data-launch-id')
            const imageGallery = document.querySelector(`[data-gallery="${imageGalleryId}"]`)
            const imageGalleryClose = document.querySelector(`[data-gallery-close="${imageGalleryId}"]`)
            const imageGalleryMain = document.querySelector(`[data-gallery-main="${imageGalleryId}"]`)
            const imageGalleryNav = document.querySelector(`[data-gallery-nav="${imageGalleryId}"]`)

            // Display background overlay
            document.body.classList.add('modal-visible')

            // Show image gallery
            imageGallery.classList.add('visible')

            // Hide background overlay and image gallery on close click
            imageGalleryClose.addEventListener('click', () => {
                document.body.classList.remove('modal-visible')
                imageGallery.classList.remove('visible')
            })

            // Setup sliders
            new Flickity(imageGalleryMain, {
                adaptiveHeight: true,
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                pageDots: false
            })

            new Flickity(imageGalleryNav, {
                asNavFor: imageGalleryMain,
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                pageDots: false,
                prevNextButtons: false
            })
        })
    }
}

export default loadImageGalleries



// WEBPACK FOOTER //
// ./js/imageGalleries.js